import { render, staticRenderFns } from "./app2.vue?vue&type=template&id=de8aef90"
var script = {}
import style0 from "./app2.vue?vue&type=style&index=0&id=de8aef90&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports